<template>
  <div id="contactList">
    <h1>Contact List</h1>
    <v-btn class="ma-2" outlined color="teal" @click="tabeRe()">
      <v-icon>mdi-flash</v-icon>Refresh
    </v-btn>
    <v-app id="inspire">
      <v-card>
        <v-card-title>
          Contact List
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="myitems" :search="search" sort-field="durations" ></v-data-table>
      </v-card>
    </v-app>
  </div>
</template>
<style scoped>
</style>
<script>
import { contactList } from "../../firebaseConfig";
export default {
  name: "contactList",
  data() {
    return {
      search: "",
       myitems: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "DeviceID", value: "deviceID" },
        { text: "Number", value: "number" },
        { text: "Uid", value: "uid" }
      ],
      desserts: [
        {
          deviceID: "Frozen Yogurt",
          durations: 159,
          name: 6.0,
          carbs: 24,
          number: 4.0,
          time: "1%"
        }
      ]
    };
  },
  mounted: function () {
    this.tabeRe();
  },
  methods: {
    async myD() {
        
     return contactList.child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1").child("868068040704056").on("value", snapshot => {
     //   console.log(snapshot.key);
        this.myitems = snapshot.val();
        //  let k[]=this.myitems.reverse;
       // console.log(snapshot.val());
      }

      );
     // this.tabeRe();
    },
   async tabeRe()
    {
       // this.myD();
        console.log("inside tablere");
        var x = await this.myD();
         console.log(x);
         this.myitems = this.myitems.slice().reverse();
      //  let d=this.myD();
       // d.then(data=>console.log("then"+data));
        //this.myitems = this.myitems.reverse;
    //    this.myD().then(data=>{
    //        console.log("mydatw"+data);
    //    })
    },
  }
};
</script>